import { catalog, plural } from '@nolens/i18n';

export const componentsText = catalog(
  {
    notFound: 'Not found',
    notFoundHint: "This content doesn't exist or you don't have access to it.",
    couldNotLoad: "Couldn't load",
    tryAgain: 'Try again.',
    seePlans: 'See plans',
    close: 'Close',
    // Leituras
    reads30: 'reads in 30 days',
    readsAria: (max: number) => `Reads per day in the last 30 days, maximum ${max}`,
    readsBy: (member: number, pub: number, embed: number) =>
      `team ${member} · link ${pub} · embed ${embed}`,
    readsAll: (n: number) => `all time: ${n}`,
    // Poupança
    period: 'Period',
    periodAll: 'Since the start',
    period3m: 'Last 3 months',
    period12m: 'Last 12 months',
    periodYear: 'This year',
    noGuidesInPeriod: 'No guides in this period yet.',
    guides: 'Guides',
    steps: 'Steps',
    estimatedSavings: 'Estimated savings',
    total: 'Total',
    // Comentários
    comments: (n: number, unresolved: number) =>
      `💬 ${n} ${plural('en', n, { one: 'comment', other: 'comments' })}` +
      (unresolved ? ` · ${unresolved} unresolved` : ''),
    addComment: '+ Comment',
    someone: 'Someone',
    resolved: '· resolved',
    reopen: 'Reopen',
    resolve: 'Resolve',
    delete: 'Delete',
    commentStep: 'Comment on this step',
    commentGuide: 'Comment on the guide',
    commentPlaceholder: 'Write a comment…',
    send: 'Send',
    // Avisos
    notifications: 'Notifications',
    notificationsUnread: (n: number) => `Notifications, ${n} unread`,
    noNotifications: 'No notifications. Follow a guide to know when it changes or gets comments.',
    notified: (who: string, kind: 'comment' | 'update', title: string) =>
      `${who} ${kind === 'comment' ? 'commented on' : 'updated'} “${title}”`,
    untitled: 'Untitled',
    personal: 'Personal',
  },
  {
    'pt-PT': {
      notFound: 'Não encontrado',
      notFoundHint: 'Este conteúdo não existe ou não tem acesso a ele.',
      couldNotLoad: 'Não foi possível carregar',
      tryAgain: 'Tente outra vez.',
      seePlans: 'Ver planos',
      close: 'Fechar',
      reads30: 'leituras em 30 dias',
      readsAria: (max) => `Leituras por dia nos últimos 30 dias, máximo ${max}`,
      readsBy: (member, pub, embed) => `equipa ${member} · ligação ${pub} · embed ${embed}`,
      readsAll: (n) => `sempre: ${n}`,
      period: 'Período',
      periodAll: 'Desde o início',
      period3m: 'Últimos 3 meses',
      period12m: 'Últimos 12 meses',
      periodYear: 'Este ano',
      noGuidesInPeriod: 'Ainda não há guias neste período.',
      guides: 'Guias',
      steps: 'Passos',
      estimatedSavings: 'Poupança estimada',
      total: 'Total',
      comments: (n, unresolved) =>
        `💬 ${n} ${plural('pt-PT', n, { one: 'comentário', other: 'comentários' })}` +
        (unresolved ? ` · ${unresolved} por resolver` : ''),
      addComment: '+ Comentar',
      someone: 'Alguém',
      resolved: '· resolvido',
      reopen: 'Reabrir',
      resolve: 'Resolver',
      delete: 'Apagar',
      commentStep: 'Comentar este passo',
      commentGuide: 'Comentar o guia',
      commentPlaceholder: 'Escreva um comentário…',
      send: 'Enviar',
      notifications: 'Avisos',
      notificationsUnread: (n) => `Avisos, ${n} por ler`,
      noNotifications: 'Sem avisos. Siga um guia para saber quando muda ou é comentado.',
      notified: (who, kind, title) =>
        `${who} ${kind === 'comment' ? 'comentou' : 'alterou'} «${title}»`,
      untitled: 'Sem título',
      personal: 'Pessoal',
    },
  },
);
